import { render } from "./Log.vue?vue&type=template&id=64a7264e&ts=true"
import script from "./Log.vue?vue&type=script&lang=ts"
export * from "./Log.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__